import { render, staticRenderFns } from "./ProgramMember.vue?vue&type=template&id=7dd96d8a&scoped=true"
import script from "./ProgramMember.vue?vue&type=script&lang=js"
export * from "./ProgramMember.vue?vue&type=script&lang=js"
import style0 from "./ProgramMember.vue?vue&type=style&index=0&id=7dd96d8a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dd96d8a",
  null
  
)

export default component.exports